<template>
  <div>
    <label v-if="inputLabel && !hiddenLabel">
      {{ inputLabel }}
      <span v-if="isMandatory" class="color-red">* </span>
    </label>
    <div>
      <div class="dropdown">
        <div v-if="valueType === 'string'">
          <input v-if="selectedItem.length === 0" ref="dropdowninput"
            v-model="inputValue" class="dropdown-input" type="text"
            :style="{height: customHeight !== 'none' ? customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)' }"
            :class="errorIndicatorHighlight"
            :placeholder="placeholderValue" autocomplete="my-field-name"/>
          <input v-else :value="selectedItem" class="dropdown-selected" type="text"
            :style="{height: customHeight !== 'none' ? customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)' }"
            :class="errorIndicatorHighlight"
            @click="resetSelection"/>
          <div v-if="inputValue && !selectedItem" v-show="inputValue"
                class="dropdown-list" v-bind:style="{'max-height': dropdownMaxHeight}">
            <div v-for="item in defaultItemList" :key="item"
                 @click="selectItem(item)" v-show="itemVisible(item)"
                  class="dropdown-item">
              {{ item }}
            </div>
          </div>
        </div>
        <div v-else-if="valueType === 'object'"> <!-- For selector with object as component value -->
          <input v-if="selectedItem.length === 0" ref="dropdowninput"
            v-model="inputValueObj" class="dropdown-input form-control inputAccordionForm"
            :style="{height: customHeight !== 'none' ? customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)' }"
            type="text" :placeholder="placeholderValue" autocomplete="my-field-name"
            :class="errorIndicatorHighlight" @blur="sendInputValueObjAsInputValue()"/>
          <input v-else :value="inputValueObj" class="dropdown-selected form-control inputAccordionForm"
            :style="{height: customHeight !== 'none' ? customHeight + 'px' : 'calc(1.5em + 0.75rem + 2px)' }"
            type="text" @click="resetSelection" :class="errorIndicatorHighlight"/>
          <div v-if="inputValueObj && !selectedItem" v-show="inputValueObj"
               class="dropdown-list" :style="{'max-height': dropdownMaxHeight}">
            <div v-for="item in defaultItemList" :key="item[objectKey]"
                @click="selectItem(item)" v-show="itemVisible(item)" class="dropdown-item">
              <div>
                <label>{{ item[valueKey] }}</label>
                <br/>
                <label>{{ item[subTextKey] }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="mandatoryErrorIndicator" style='color:red;'>
        {{ $t('errors.is_mandatory', {mandatoryValue :inputLabel }) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'formDropdownInput',
  props: {
    customHeight: {
      type: String,
      default: 'none'
    },
    inputLabel: {
      type: String
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    mandatoryErrorIndicator: {
      type: Boolean,
      default: false
    },
    placeholderValue: {
      type: String
    },
    itemList: {
      type: Array
    },
    value: {
      default: ''
    },
    valueKey: {
      type: String
    },
    objectKey: {
      type: String
    },
    subTextKey: {
      type: String
    },
    dropdownMaxHeight: {
      type: String,
      default: '84px'
    }
  },
  data () {
    return {
      selectedItem: '',
      inputValueObj: ''
    }
  },
  methods: {
    resetSelection () {
      // désactivé pour l'instant
      if (this) {
        return
      }
      this.selectedItem = ''
      this.$nextTick(() => this.$refs.dropdowninput.focus())
      if (this.valueType === 'object') {
        this.inputValueObj = ''
        this.$emit('input', {})
      } else {
        this.inputValue = ''
      }
    },
    selectItem (selectedItem) {
      this.selectedItem = selectedItem
      if (this.valueType === 'object') {
        this.inputValueObj = selectedItem[this.valueKey]
        this.$emit('input', selectedItem)
      } else {
        this.inputValue = selectedItem
      }
    },
    itemVisible (item) {
      let currentName = (typeof item === 'object') ? item[this.valueKey].toLowerCase() : item.toLowerCase()
      let currentInput = this.valueType === 'object' ? this.inputValueObj.toLowerCase() : this.inputValue.toLowerCase()
      if (currentName === currentInput) {
        return false
      }
      return currentName.includes(currentInput)
    },
    /** @author TLV 24/02/2021
    * @brief Bricolage pour que le nom saisi manuellement par l'utilisateur soit gardé sur l'interface,
    *       même s'il ne choisit pas un nom dans la liste de suggestion.
    * @details Ce component entier est inutilement complexe ("usine à gaz"), il faudrait se prendre
    *           le temps de le réécrire plus simplement, notamment sans avoir besoin de faire de distinction du type de la value object/string.
    */
    sendInputValueObjAsInputValue () {
      let visibleItemsList = []
      for (let i = 0; i < this.defaultItemList.length; i++) {
        if (this.itemVisible(this.defaultItemList[i])) {
          visibleItemsList.push(this.defaultItemList[i])
        }
      }
      if (visibleItemsList.length === 0 && this.valueType === 'object') {
        this.selectItem({name: this.inputValueObj})
      }
    }
  },
  computed: {
    errorIndicatorHighlight () {
      if (this.mandatoryErrorIndicator) {
        return 'errorBorder'
      }
      return ''
    },
    // Item list is the contacts list by default
    defaultItemList () {
      if (this.itemList == null) {
        return this.$engine.contacts.get()
      }
      return this.itemList
    },
    valueType: {
      get () {
        if (typeof this.value === 'object') {
          return Array.isArray(this.value) ? 'array' : 'object'
        }
        return 'string'
      }
    },
    inputValue: {
      get () {
        return (this.valueType === 'string') ? this.value : this.value[this.valueKey]
      },
      set (val) {
        if (this.valueType === 'string') {
          this.$emit('input', val)
        }
      }
    }
  }
}
</script>

<style scoped>
.dropdown{
  position: relative;
  width: 100%;
  margin: 0;
}
.dropdown-input, .dropdown-selected{
  width: 100%;
  outline: none;
}
.dropdown-input:focus, .dropdown-selected:hover{
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder{
  opacity: 0.7;
  color: #333;
}
.dropdown-selected{
  cursor: pointer;
}
.dropdown-list{
  position: absolute;
  z-index: 30000;
  width: 100%;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}
.dropdown-item{
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
}
.dropdown-item:hover{
  background: #edf2f7;
}
.dropdown-item-flag{
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}
</style>



// WEBPACK FOOTER //
// formDropdownLabelInput.vue?fa39f4b2